const ConsentCategory = {
    TechnicallyRequired: "c1",
    Functional: "c51",
    MarketingAndAdvertising: "c52",
};
export const GenericCMP = {
    isPresent: () => {
        return "__cmp" in window;
    },
    hasGrantedPermission: () => {
        if (!window.__cmp) {
            return false;
        }
        const data = window.__cmp("getCMPData");
        const consents = data.purposeConsents;
        return Boolean(consents[ConsentCategory.MarketingAndAdvertising]);
    },
    onConsentChanged: (callback) => {
        if (!window.__cmp) {
            return;
        }
        window.__cmp("addEventListener", ["consent", callback, null]);
        window.__cmp("addEventListener", ["consentapproved", callback, null]);
        window.__cmp("addEventListener", ["consentrejected", callback, null]);
    },
};
